import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ICatalogItem } from '../../shared/types/card';
import { getStoreLocal, setStoreLocal } from '../../utils/local-storage';

import { FavoritePageState } from './favorite.interface';

const getCountFavorite = getStoreLocal('favorite');

const initialState: FavoritePageState = {
  favorites: getStoreLocal('favorite') || [],
  favoriteQuantity: getCountFavorite ? getCountFavorite.length : 0,
};

export const favoritePageSlice = createSlice({
  name: 'basketPageSlice',
  initialState,
  reducers: {
    setFavoriteQuantity: (state, action: PayloadAction<number>) => {
      state.favoriteQuantity = action.payload;
    },
    setFavoriteItems(state, action: PayloadAction<ICatalogItem[]>) {
      state.favorites = action.payload;
      setStoreLocal('favorite', action.payload);
    },
  },
});
export const favoriteActions = favoritePageSlice.actions;
export const { reducer } = favoritePageSlice;
